module.exports = __webpack_public_path__ + "static/media/home-pruefv.f04399dc.jpeg";